const Currencies = [
  { key: "USD", label: "US Dollar (USD)" },
  { key: "EUR", label: "Euro (EUR)" },
  { key: "GBP", label: "British Pound (GBP)" },
  { key: "CAD", label: "Canadian Dollar (CAD)" },
  { key: "AFN", label: "Afghan Afghani (AFN)" },
  { key: "ALL", label: "Albanian Lek (ALL)" },
  { key: "DZD", label: "Algerian Dinar (DZD)" },
  { key: "AOA", label: "Angolan Kwanza (AOA)" },
  { key: "ARS", label: "Argentine Peso (ARS)" },
  { key: "AMD", label: "Armenian Dram (AMD)" },
  { key: "AWG", label: "Aruban Florin (AWG)" },
  { key: "AUD", label: "Australian Dollar (AUD)" },
  { key: "BBD", label: "Barbadian Dollar (BBD)" },
  { key: "AZN", label: "Azerbaijani Manat (AZN)" },
  { key: "BDT", label: "Bangladeshi Taka (BDT)" },
  { key: "BSD", label: "Bahamian Dollar (BSD)" },
  { key: "BHD", label: "Bahraini Dinar (BHD)" },
  { key: "BIF", label: "Burundian Franc (BIF)" },
  { key: "BYN", label: "Belarusian Ruble (BYN)" },
  { key: "BYR", label: "Belarusian Ruble (BYR)" },
  { key: "BZD", label: "Belize Dollar (BZD)" },
  { key: "BMD", label: "Bermudan Dollar (BMD)" },
  { key: "BTN", label: "Bhutanese Ngultrum (BTN)" },
  { key: "BAM", label: "Bosnia-Herzegovina Convertible Mark (BAM)" },
  { key: "BRL", label: "Brazilian Real (BRL)" },
  { key: "BOB", label: "Bolivian Boliviano (BOB)" },
  { key: "BWP", label: "Botswanan Pula (BWP)" },
  { key: "BND", label: "Brunei Dollar (BND)" },
  { key: "BGN", label: "Bulgarian Lev (BGN)" },
  { key: "MMK", label: "Myanmar Kyat (MMK)" },
  { key: "KHR", label: "Cambodian Riel (KHR)" },
  { key: "CVE", label: "Cape Verdean Escudo (CVE)" },
  { key: "KYD", label: "Cayman Islands Dollar (KYD)" },
  { key: "XAF", label: "Central African CFA Franc (XAF)" },
  { key: "CLP", label: "Chilean Peso (CLP)" },
  { key: "CNY", label: "Chinese Yuan (CNY)" },
  { key: "COP", label: "Colombian Peso (COP)" },
  { key: "KMF", label: "Comorian Franc (KMF)" },
  { key: "CDF", label: "Congolese Franc (CDF)" },
  { key: "CRC", label: "Costa Rican Colón (CRC)" },
  { key: "HRK", label: "Croatian Kuna (HRK)" },
  { key: "CZK", label: "Czech Koruna (CZK)" },
  { key: "DKK", label: "Danish Krone (DKK)" },
  { key: "DJF", label: "Djiboutian Franc (DJF)" },
  { key: "DOP", label: "Dominican Peso (DOP)" },
  { key: "XCD", label: "East Caribbean Dollar (XCD)" },
  { key: "EGP", label: "Egyptian Pound (EGP)" },
  { key: "ETB", label: "Ethiopian Birr (ETB)" },
  { key: "FKP", label: "Falkland Islands Pound (FKP)" },
  { key: "XPF", label: "CFP Franc (XPF)" },
  { key: "FJD", label: "Fijian Dollar (FJD)" },
  { key: "GIP", label: "Gibraltar Pound (GIP)" },
  { key: "GMD", label: "Gambian Dalasi (GMD)" },
  { key: "GHS", label: "Ghanaian Cedi (GHS)" },
  { key: "GTQ", label: "Guatemalan Quetzal (GTQ)" },
  { key: "GYD", label: "Guyanaese Dollar (GYD)" },
  { key: "GEL", label: "Georgian Lari (GEL)" },
  { key: "GNF", label: "Guinean Franc (GNF)" },
  { key: "HTG", label: "Haitian Gourde (HTG)" },
  { key: "HNL", label: "Honduran Lempira (HNL)" },
  { key: "HKD", label: "Hong Kong Dollar (HKD)" },
  { key: "HUF", label: "Hungarian Forint (HUF)" },
  { key: "ISK", label: "Icelandic Króna (ISK)" },
  { key: "INR", label: "Indian Rupee (INR)" },
  { key: "IDR", label: "Indonesian Rupiah (IDR)" },
  { key: "ILS", label: "Israeli New Shekel (ILS)" },
  { key: "IRR", label: "Iranian Rial (IRR)" },
  { key: "IQD", label: "Iraqi Dinar (IQD)" },
  { key: "JMD", label: "Jamaican Dollar (JMD)" },
  { key: "JPY", label: "Japanese Yen (JPY)" },
  { key: "JEP", label: "Jersey Pound (JEP)" },
  { key: "JOD", label: "Jordanian Dinar (JOD)" },
  { key: "KZT", label: "Kazakhstani Tenge (KZT)" },
  { key: "KES", label: "Kenyan Shilling (KES)" },
  { key: "KWD", label: "Kuwaiti Dinar (KWD)" },
  { key: "KGS", label: "Kyrgystani Som (KGS)" },
  { key: "LAK", label: "Laotian Kip (LAK)" },
  { key: "LVL", label: "Latvian Lats (LVL)" },
  { key: "LBP", label: "Lebanese Pound (LBP)" },
  { key: "LSL", label: "Lesotho Loti (LSL)" },
  { key: "LRD", label: "Liberian Dollar (LRD)" },
  { key: "LYD", label: "Libyan Dinar (LYD)" },
  { key: "MGA", label: "Malagasy Ariary (MGA)" },
  { key: "MKD", label: "Macedonian Denar (MKD)" },
  { key: "MOP", label: "Macanese Pataca (MOP)" },
  { key: "MWK", label: "Malawian Kwacha (MWK)" },
  { key: "MVR", label: "Maldivian Rufiyaa (MVR)" },
  { key: "MXN", label: "Mexican Peso (MXN)" },
  { key: "MYR", label: "Malaysian Ringgit (MYR)" },
  { key: "MUR", label: "Mauritian Rupee (MUR)" },
  { key: "MDL", label: "Moldovan Leu (MDL)" },
  { key: "MAD", label: "Moroccan Dirham (MAD)" },
  { key: "MNT", label: "Mongolian Tugrik (MNT)" },
  { key: "MZN", label: "Mozambican Metical (MZN)" },
  { key: "NAD", label: "Namibian Dollar (NAD)" },
  { key: "NPR", label: "Nepalese Rupee (NPR)" },
  { key: "ANG", label: "Netherlands Antillean Guilder (ANG)" },
  { key: "NZD", label: "New Zealand Dollar (NZD)" },
  { key: "NIO", label: "Nicaraguan Córdoba (NIO)" },
  { key: "NGN", label: "Nigerian Naira (NGN)" },
  { key: "NOK", label: "Norwegian Krone (NOK)" },
  { key: "OMR", label: "Omani Rial (OMR)" },
  { key: "PAB", label: "Panamanian Balboa (PAB)" },
  { key: "PKR", label: "Pakistani Rupee (PKR)" },
  { key: "PGK", label: "Papua New Guinean Kina (PGK)" },
  { key: "PYG", label: "Paraguayan Guarani (PYG)" },
  { key: "PEN", label: "Peruvian Sol (PEN)" },
  { key: "PHP", label: "Philippine Piso (PHP)" },
  { key: "PLN", label: "Polish Zloty (PLN)" },
  { key: "QAR", label: "Qatari Rial (QAR)" },
  { key: "RON", label: "Romanian Leu (RON)" },
  { key: "RUB", label: "Russian Ruble (RUB)" },
  { key: "RWF", label: "Rwandan Franc (RWF)" },
  { key: "WST", label: "Samoan Tala (WST)" },
  { key: "SHP", label: "St. Helena Pound (SHP)" },
  { key: "SAR", label: "Saudi Riyal (SAR)" },
  { key: "STD", label: "São Tomé & Príncipe Dobra (STD)" },
  { key: "RSD", label: "Serbian Dinar (RSD)" },
  { key: "SCR", label: "Seychellois Rupee (SCR)" },
  { key: "SLL", label: "Sierra Leonean Leone (SLL)" },
  { key: "SGD", label: "Singapore Dollar (SGD)" },
  { key: "SDG", label: "Sudanese Pound (SDG)" },
  { key: "SYP", label: "Syrian Pound (SYP)" },
  { key: "ZAR", label: "South African Rand (ZAR)" },
  { key: "KRW", label: "South Korean Won (KRW)" },
  { key: "SSP", label: "South Sudanese Pound (SSP)" },
  { key: "SBD", label: "Solomon Islands Dollar (SBD)" },
  { key: "LKR", label: "Sri Lankan Rupee (LKR)" },
  { key: "SRD", label: "Surinamese Dollar (SRD)" },
  { key: "SZL", label: "Swazi Lilangeni (SZL)" },
  { key: "SEK", label: "Swedish Krona (SEK)" },
  { key: "CHF", label: "Swiss Franc (CHF)" },
  { key: "TWD", label: "New Taiwan Dollar (TWD)" },
  { key: "THB", label: "Thai Baht (THB)" },
  { key: "TJS", label: "Tajikistani Somoni (TJS)" },
  { key: "TZS", label: "Tanzanian Shilling (TZS)" },
  { key: "TOP", label: "Tongan Paʻanga (TOP)" },
  { key: "TTD", label: "Trinidad & Tobago Dollar (TTD)" },
  { key: "TND", label: "Tunisian Dinar (TND)" },
  { key: "TRY", label: "Turkish Lira (TRY)" },
  { key: "TMT", label: "Turkmenistani Manat (TMT)" },
  { key: "UGX", label: "Ugandan Shilling (UGX)" },
  { key: "UAH", label: "Ukrainian Hryvnia (UAH)" },
  { key: "AED", label: "United Arab Emirates Dirham (AED)" },
  { key: "UYU", label: "Uruguayan Peso (UYU)" },
  { key: "UZS", label: "Uzbekistani Som (UZS)" },
  { key: "VUV", label: "Vanuatu Vatu (VUV)" },
  { key: "VEF", label: "Venezuelan Bolívar (VEF)" },
  { key: "VND", label: "Vietnamese Dong (VND)" },
  { key: "XOF", label: "West African CFA Franc (XOF)" },
  { key: "YER", label: "Yemeni Rial (YER)" },
  { key: "ZMW", label: "Zambian Kwacha (ZMW)" }
];

export default Currencies;